export const LIST_KEY = 'documentLibrary';

export const CREATE_FOLDER_FORM = 'createFolderForm';
export const UPLOAD_FILE_FORM = 'uploadFileForm';

export const allowedExtensions = '.pdf, .jpg, .jpeg, .png';
